var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atom-dialog',{staticClass:"molecule-notice-dialog",style:({transform: _vm.transform})},[_c('atom-notice',_vm._b({},'atom-notice',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }